export const colors = [
  'var(--fu-pink)',
  'var(--fu-blue-3)',
  'var(--fu-orange-3)',
  'var(--fu-green-3)',
  'var(--fu-pink-2)',
  'var(--fu-purple-2)',
  'var(--fu-green-5)',
  'var(--fu-orange-5)',
  'var(--fu-orange-6)',
  'var(--fu-green-6)',
  'var(--fu-body-color)',
  'var(--fu-grey-20)',
  'var(--fu-grey-19)',
];

export const icons = [
  'activity-heart-solid',
  'award-solid',
  'back',
  'backbone',
  'bicycle',
  'blood-pressure',
  'calendar-solid',
  'chair-massage',
  'confetti-solid',
  'cross-country',
  'gift-solid',
  'health-screening',
  'hearts-solid',
  'help-circle-solid',
  'hiking',
  'info-circle-solid',
  'interval',
  'kettlebell',
  'kettlebell-solid',
  'lightbulb-solid',
  'lotus',
  'massage',
  'medical-cross-solid',
  'meditation-solid',
  'pilates',
  'run',
  'running',
  'ski',
  'syringe',
  'ticket-solid',
  'trophy-solid',
  'vision',
  'yoga',
  'zap-solid',
];
